import * as actions from './actions';

const initialState = {
	showDialog: false,
	restarting: false,
	timeout: false,
	error: false,
	errorDetail: null
};

export const restart = (state, action) => {
	state = state || initialState;
	switch (action.type) {
		// Set restarting status and reset the rest of the state
		case actions.AWAIT_RESTART:
			return {
				...initialState,
				showDialog: !!action.payload.showDialog,
				restarting: true
			};

		// Reset state completely when restart is completed
		case actions.AWAIT_RESTART_SUCCESS:
			return initialState;

		// Set timeout status and keep the rest of the state
		case actions.AWAIT_RESTART_TIMEOUT:
			return {
				...state,
				restarting: false,
				timeout: true
			};

		// Set error status and keep the rest of the state
		case actions.AWAIT_RESTART_ERROR:
			return {
				...state,
				error: true,
				errorDetail: action.payload,
				restarting: false
			};

		default:
			return state;
	}
};
